import { Navigate, Route, Routes } from 'react-router-dom'
import PlatformPrivateRoute from './components/PlatformPrivateRoute'
import PlatformLayout from './components/PlatformLayout'
import RequirePerm from './components/RequirePerm'
import { PERM } from './platformRoles'
import AdminLogin from './pages/AdminLogin'
import AdminForgotPassword from './pages/AdminForgotPassword'
import AdminResetPassword from './pages/AdminResetPassword'
import TenantsList from './pages/TenantsList'
import TenantDetail from './pages/TenantDetail'
import AdminsList from './pages/AdminsList'
import HelpdeskList from './pages/HelpdeskList'
import HelpdeskTicketDetail from './pages/HelpdeskTicketDetail'
import PlatformSettings from './pages/PlatformSettings'
import PlanosList from './pages/PlanosList'
import SubscricoesList from './pages/SubscricoesList'
import CobrancasList from './pages/CobrancasList'
import PagamentosList from './pages/PagamentosList'

/** Rotas do painel de administração da plataforma (admin.<dominio-raiz>). */
export default function PlatformAdminApp() {
    return (
        <Routes>
            <Route path="/login" element={<AdminLogin />} />
            <Route path="/forgot-password" element={<AdminForgotPassword />} />
            <Route path="/reset-password" element={<AdminResetPassword />} />
            <Route
                path="/"
                element={
                    <PlatformPrivateRoute>
                        <PlatformLayout />
                    </PlatformPrivateRoute>
                }
            >
                <Route index element={<Navigate to="/tenants" replace />} />
                {/* Base — qualquer admin activo: listar/ver empresas e ver definições. */}
                <Route path="tenants" element={<TenantsList />} />
                <Route path="tenants/:id" element={<TenantDetail />} />
                <Route path="settings" element={<PlatformSettings />} />
                {/* Áreas restritas por permissão fina. */}
                <Route
                    path="helpdesk"
                    element={<RequirePerm perm={PERM.SUPORTE_MANAGE}><HelpdeskList /></RequirePerm>}
                />
                <Route
                    path="helpdesk/:id"
                    element={<RequirePerm perm={PERM.SUPORTE_MANAGE}><HelpdeskTicketDetail /></RequirePerm>}
                />
                <Route
                    path="admins"
                    element={<RequirePerm perm={PERM.ADMINS_MANAGE}><AdminsList /></RequirePerm>}
                />
                <Route
                    path="planos"
                    element={<RequirePerm perm={PERM.PLANOS_MANAGE}><PlanosList /></RequirePerm>}
                />
                <Route
                    path="subscricoes"
                    element={<RequirePerm perm={PERM.SUBSCRICOES_MANAGE}><SubscricoesList /></RequirePerm>}
                />
                <Route
                    path="cobrancas"
                    element={<RequirePerm perm={PERM.FATURACAO_MANAGE}><CobrancasList /></RequirePerm>}
                />
                <Route
                    path="pagamentos"
                    element={<RequirePerm perm={PERM.FATURACAO_MANAGE}><PagamentosList /></RequirePerm>}
                />
                <Route path="*" element={<Navigate to="/tenants" replace />} />
            </Route>
        </Routes>
    )
}
